<i18n>
{
    "ar": {
        
    },
    "en": {
        
    }
}
</i18n>
<template>
    <div class="page page-sections">
        <v-container :style="`min-height: ${pcOnly ? '75vh' : '60vh'}`" class="py-lg-12 d-flex align-center justify-center flex-column">
            <v-card :min-width="pcOnly ? 500 : undefined" class="search-card px-lg-2 py-1">
                <v-card-title :class="{'justify-center': phoneOnly}">الاستعلام عن فاتورة والسداد</v-card-title>
                <v-card-subtitle :class="{'text-center': phoneOnly}">أدخل رقم لفاتورة لعرض تفاصيلها أو تسديد القيمة المستحقة</v-card-subtitle>
                <v-card-text class="px-lg-6 px-2 pt-2 pt-lg-4">
                    <v-alert v-if="$route.query.error === '404'" dense type="error" text>
                        الفاتورة التي بحثت عنها غير موجودة
                    </v-alert>
                    <v-form>
                        <v-text-field v-model="serialNumber" color="blue darken-2" outlined label="رقم الفاتورة" placeholder="أدخل رقم الفاتورة الذي وصلك على بريدك اﻹلكتروني"></v-text-field>
                    </v-form>
                    <v-btn :disabled="!serialNumber" :to="{name: 'invoice', params: {id: serialNumber}}" large color="primary" block>البحث عن الفاتورة</v-btn>
                </v-card-text>
            </v-card>
        </v-container>
        <e-footer />
        <scroll-to-top />
    </div>
</template>

<script>
// @ is an alias to /src
import 'particles.js';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles


import ScrollToTop from '@/components/custom/scroll-to-top'
import EFooter from '@/components/main/e-footer'


import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: "Invoices",
    components: {
        ScrollToTop,
        EFooter,
    },
    data(){
        return {
            serialNumber: '',
        }
    },
    computed: {
        
        ...GlobalComputed
    },
    methods: {

        ...GlobalMethods
    },
    watch: {
        
    },

    mounted(){
        AOS.init({container: document.documentElement, once: true, easing: 'ease'});
    }
};
</script>
<style lang="scss" scoped>
.search-card{
    box-shadow: none!important;
    @media(min-width: 960px){
        box-shadow: 0 4px 8px 2px rgba(0,0,0, .1)!important;
    }
}
</style>